/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkoutShareRouteImport } from './routes/workoutShare'
import { Route as ShareTemplateRouteImport } from './routes/shareTemplate'
import { Route as ResetPasswordRouteImport } from './routes/resetPassword'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgotPassword'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppWorkoutRouteImport } from './routes/_app.workout'
import { Route as AppWeightRouteImport } from './routes/_app.weight'
import { Route as AppTemplatesRouteImport } from './routes/_app.templates'
import { Route as AppSmolovJrRouteImport } from './routes/_app.smolov-jr'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppProgramsRouteImport } from './routes/_app.programs'
import { Route as AppPlateCalculatorRouteImport } from './routes/_app.plate-calculator'
import { Route as AppHomeRouteImport } from './routes/_app.home'
import { Route as AppHistoryRouteImport } from './routes/_app.history'
import { Route as AppExercisesRouteImport } from './routes/_app.exercises'
import { Route as AppCalendarRouteImport } from './routes/_app.calendar'
import { Route as AppProgramIdRouteImport } from './routes/_app.program.$id'

const WorkoutShareRoute = WorkoutShareRouteImport.update({
  id: '/workoutShare',
  path: '/workoutShare',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareTemplateRoute = ShareTemplateRouteImport.update({
  id: '/shareTemplate',
  path: '/shareTemplate',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/resetPassword',
  path: '/resetPassword',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgotPassword',
  path: '/forgotPassword',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppWorkoutRoute = AppWorkoutRouteImport.update({
  id: '/workout',
  path: '/workout',
  getParentRoute: () => AppRoute,
} as any)
const AppWeightRoute = AppWeightRouteImport.update({
  id: '/weight',
  path: '/weight',
  getParentRoute: () => AppRoute,
} as any)
const AppTemplatesRoute = AppTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppRoute,
} as any)
const AppSmolovJrRoute = AppSmolovJrRouteImport.update({
  id: '/smolov-jr',
  path: '/smolov-jr',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppProgramsRoute = AppProgramsRouteImport.update({
  id: '/programs',
  path: '/programs',
  getParentRoute: () => AppRoute,
} as any)
const AppPlateCalculatorRoute = AppPlateCalculatorRouteImport.update({
  id: '/plate-calculator',
  path: '/plate-calculator',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)
const AppHistoryRoute = AppHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AppRoute,
} as any)
const AppExercisesRoute = AppExercisesRouteImport.update({
  id: '/exercises',
  path: '/exercises',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppProgramIdRoute = AppProgramIdRouteImport.update({
  id: '/program/$id',
  path: '/program/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgotPassword': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/resetPassword': typeof ResetPasswordRoute
  '/shareTemplate': typeof ShareTemplateRoute
  '/workoutShare': typeof WorkoutShareRoute
  '/calendar': typeof AppCalendarRoute
  '/exercises': typeof AppExercisesRoute
  '/history': typeof AppHistoryRoute
  '/home': typeof AppHomeRoute
  '/plate-calculator': typeof AppPlateCalculatorRoute
  '/programs': typeof AppProgramsRoute
  '/settings': typeof AppSettingsRoute
  '/smolov-jr': typeof AppSmolovJrRoute
  '/templates': typeof AppTemplatesRoute
  '/weight': typeof AppWeightRoute
  '/workout': typeof AppWorkoutRoute
  '/program/$id': typeof AppProgramIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgotPassword': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/resetPassword': typeof ResetPasswordRoute
  '/shareTemplate': typeof ShareTemplateRoute
  '/workoutShare': typeof WorkoutShareRoute
  '/calendar': typeof AppCalendarRoute
  '/exercises': typeof AppExercisesRoute
  '/history': typeof AppHistoryRoute
  '/home': typeof AppHomeRoute
  '/plate-calculator': typeof AppPlateCalculatorRoute
  '/programs': typeof AppProgramsRoute
  '/settings': typeof AppSettingsRoute
  '/smolov-jr': typeof AppSmolovJrRoute
  '/templates': typeof AppTemplatesRoute
  '/weight': typeof AppWeightRoute
  '/workout': typeof AppWorkoutRoute
  '/program/$id': typeof AppProgramIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/forgotPassword': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/resetPassword': typeof ResetPasswordRoute
  '/shareTemplate': typeof ShareTemplateRoute
  '/workoutShare': typeof WorkoutShareRoute
  '/_app/calendar': typeof AppCalendarRoute
  '/_app/exercises': typeof AppExercisesRoute
  '/_app/history': typeof AppHistoryRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/plate-calculator': typeof AppPlateCalculatorRoute
  '/_app/programs': typeof AppProgramsRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/smolov-jr': typeof AppSmolovJrRoute
  '/_app/templates': typeof AppTemplatesRoute
  '/_app/weight': typeof AppWeightRoute
  '/_app/workout': typeof AppWorkoutRoute
  '/_app/program/$id': typeof AppProgramIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgotPassword'
    | '/login'
    | '/logout'
    | '/privacy'
    | '/register'
    | '/resetPassword'
    | '/shareTemplate'
    | '/workoutShare'
    | '/calendar'
    | '/exercises'
    | '/history'
    | '/home'
    | '/plate-calculator'
    | '/programs'
    | '/settings'
    | '/smolov-jr'
    | '/templates'
    | '/weight'
    | '/workout'
    | '/program/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgotPassword'
    | '/login'
    | '/logout'
    | '/privacy'
    | '/register'
    | '/resetPassword'
    | '/shareTemplate'
    | '/workoutShare'
    | '/calendar'
    | '/exercises'
    | '/history'
    | '/home'
    | '/plate-calculator'
    | '/programs'
    | '/settings'
    | '/smolov-jr'
    | '/templates'
    | '/weight'
    | '/workout'
    | '/program/$id'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/forgotPassword'
    | '/login'
    | '/logout'
    | '/privacy'
    | '/register'
    | '/resetPassword'
    | '/shareTemplate'
    | '/workoutShare'
    | '/_app/calendar'
    | '/_app/exercises'
    | '/_app/history'
    | '/_app/home'
    | '/_app/plate-calculator'
    | '/_app/programs'
    | '/_app/settings'
    | '/_app/smolov-jr'
    | '/_app/templates'
    | '/_app/weight'
    | '/_app/workout'
    | '/_app/program/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  PrivacyRoute: typeof PrivacyRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  ShareTemplateRoute: typeof ShareTemplateRoute
  WorkoutShareRoute: typeof WorkoutShareRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workoutShare': {
      id: '/workoutShare'
      path: '/workoutShare'
      fullPath: '/workoutShare'
      preLoaderRoute: typeof WorkoutShareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shareTemplate': {
      id: '/shareTemplate'
      path: '/shareTemplate'
      fullPath: '/shareTemplate'
      preLoaderRoute: typeof ShareTemplateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resetPassword': {
      id: '/resetPassword'
      path: '/resetPassword'
      fullPath: '/resetPassword'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgotPassword': {
      id: '/forgotPassword'
      path: '/forgotPassword'
      fullPath: '/forgotPassword'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/workout': {
      id: '/_app/workout'
      path: '/workout'
      fullPath: '/workout'
      preLoaderRoute: typeof AppWorkoutRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/weight': {
      id: '/_app/weight'
      path: '/weight'
      fullPath: '/weight'
      preLoaderRoute: typeof AppWeightRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/templates': {
      id: '/_app/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof AppTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/smolov-jr': {
      id: '/_app/smolov-jr'
      path: '/smolov-jr'
      fullPath: '/smolov-jr'
      preLoaderRoute: typeof AppSmolovJrRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/programs': {
      id: '/_app/programs'
      path: '/programs'
      fullPath: '/programs'
      preLoaderRoute: typeof AppProgramsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plate-calculator': {
      id: '/_app/plate-calculator'
      path: '/plate-calculator'
      fullPath: '/plate-calculator'
      preLoaderRoute: typeof AppPlateCalculatorRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/history': {
      id: '/_app/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof AppHistoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/exercises': {
      id: '/_app/exercises'
      path: '/exercises'
      fullPath: '/exercises'
      preLoaderRoute: typeof AppExercisesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar': {
      id: '/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/program/$id': {
      id: '/_app/program/$id'
      path: '/program/$id'
      fullPath: '/program/$id'
      preLoaderRoute: typeof AppProgramIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppCalendarRoute: typeof AppCalendarRoute
  AppExercisesRoute: typeof AppExercisesRoute
  AppHistoryRoute: typeof AppHistoryRoute
  AppHomeRoute: typeof AppHomeRoute
  AppPlateCalculatorRoute: typeof AppPlateCalculatorRoute
  AppProgramsRoute: typeof AppProgramsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppSmolovJrRoute: typeof AppSmolovJrRoute
  AppTemplatesRoute: typeof AppTemplatesRoute
  AppWeightRoute: typeof AppWeightRoute
  AppWorkoutRoute: typeof AppWorkoutRoute
  AppProgramIdRoute: typeof AppProgramIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCalendarRoute: AppCalendarRoute,
  AppExercisesRoute: AppExercisesRoute,
  AppHistoryRoute: AppHistoryRoute,
  AppHomeRoute: AppHomeRoute,
  AppPlateCalculatorRoute: AppPlateCalculatorRoute,
  AppProgramsRoute: AppProgramsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppSmolovJrRoute: AppSmolovJrRoute,
  AppTemplatesRoute: AppTemplatesRoute,
  AppWeightRoute: AppWeightRoute,
  AppWorkoutRoute: AppWorkoutRoute,
  AppProgramIdRoute: AppProgramIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  PrivacyRoute: PrivacyRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  ShareTemplateRoute: ShareTemplateRoute,
  WorkoutShareRoute: WorkoutShareRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
